// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xD x5","addMyListButton":"xE yd","wrapperNeonRental":"xF x6","upperParts":"xG"};